import React from "react";
import Chip from "@mui/material/Chip";
import {
  estadoAgente,
  etiquetaEstado,
  COLOR_ESTADO_DESCONOCIDO,
} from "consts/estados-agente";

/**
 * Chip de estado de un agente. Lo comparten la columna de la grilla y el modal de
 * cambio de estado, para que el mismo estado se vea igual en los dos lados.
 *
 * Recibe el CÓDIGO (`rnhAgenteStatus`), que es de donde sale el color. `label` es
 * opcional: sirve cuando quien llama ya tiene la etiqueta a mano (la grilla la guarda
 * en la fila); si no se pasa, se deriva del código.
 *
 * Un código desconocido se pinta gris y muestra el valor crudo, en vez de esconderlo.
 *
 * `compacto` lo achica para cuando va al lado de un texto y no en su propia celda,
 * como en las cards de asignación.
 */
export default function EstadoAgenteChip({ cod, label, compacto = false }) {
  const texto = label ?? etiquetaEstado(cod);
  if (!texto) return null;

  const color = estadoAgente(cod)?.color ?? COLOR_ESTADO_DESCONOCIDO;

  return (
    <Chip
      label={texto}
      size="small"
      sx={{
        backgroundColor: color.fondo,
        color: color.texto,
        border: `1px solid ${color.borde}`,
        // Hereda la tipografía del contenedor en vez de fijarla: el Chip de MUI
        // trae su propio font-size, y así el chip sigue a la página (celda de
        // grilla o modal) y no al revés.
        fontFamily: "inherit",
        fontSize: compacto ? "11px" : "inherit",
        maxWidth: "max-content",
        fontWeight: "inherit",
        // Las filas de la grilla son de 36px: el chip tiene que entrar sin
        // estirarlas.
        height: compacto ? "18px" : "22px",
        ...(compacto && {
          "& .MuiChip-label": { paddingLeft: "7px", paddingRight: "7px" },
        }),
      }}
    />
  );
}
